var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUygunakiralaicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 319.446,
    height: 99.4,
    viewBox: "0 0 319.446 99.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -2.197,
    y1: 8.159,
    x2: -2.197,
    y2: 8.141,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcd947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe577"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe5779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#38eaa0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77fec6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -19.982,
    y1: 24.693,
    x2: -19.982,
    y2: 24.629,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -39.754,
    y1: 43.551,
    x2: -39.754,
    y2: 43.406,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -5.538,
    y1: 20.545,
    x2: -5.538,
    y2: 20.484,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_751",
    "data-name": "Group 751",
    transform: "translate(-140 -48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M297.621,423.139h9.334V412.187l7.377,10.953h11.385L315,409.853l10.524-13.429H314.336L306.959,406.9v-19h-9.338Zm54.812-11.667c0-4.1,2.143-5.334,6-5.334h2.619v-9.953a10.6,10.6,0,0,0-8.623,4.953v-4.714H343.1v26.715h9.334Zm10.429-1.714c0,8.527,5.048,13.715,11.381,13.715,3.762,0,6.477-1.667,7.857-4.048v3.715h9.334V396.424H382.1v3.715c-1.381-2.381-4.048-4.048-7.857-4.048C367.91,396.091,362.862,401.234,362.862,409.758Zm19.239,0c0,3.619-2.238,5.571-4.858,5.571-2.666,0-4.858-2-4.858-5.571,0-3.619,2.19-5.524,4.858-5.524C379.862,404.234,382.1,406.186,382.1,409.758Zm14.669,13.381H406.1V387.9h-9.334Zm13.143-13.382c0,8.527,5.048,13.715,11.381,13.715,3.763,0,6.477-1.667,7.857-4.048v3.715h9.334V396.424h-9.331v3.715c-1.381-2.381-4.048-4.048-7.857-4.048-6.337,0-11.385,5.143-11.385,13.667Zm19.239,0c0,3.619-2.238,5.571-4.858,5.571-2.666,0-4.857-2-4.857-5.571,0-3.619,2.19-5.524,4.857-5.524,2.619,0,4.86,1.954,4.86,5.525Z",
    transform: "translate(-6.369 -299.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(140 48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(47.85 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M271.066,345.548s-52.943-3.788-81.368,51.744C189.7,397.292,246.25,398.62,271.066,345.548Z",
    transform: "translate(-189.698 -345.493)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M139.755,402.2c0,27.87,17.766,42.031,41.32,42.031,23.433,0,42.846-14.144,42.846-42.031V359a13.51,13.51,0,0,0-13.509-13.509h-.173A13.509,13.509,0,0,0,196.729,359v43.2c0,10.122-4.853,16.5-15.114,16.5s-14.836-6.378-14.836-16.5V359a13.51,13.51,0,0,0-13.509-13.509h0A13.509,13.509,0,0,0,139.761,359Z",
    transform: "translate(-139.755 -345.493)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M189.7,399.535s20.646,41.95,81.368,32C271.066,431.539,243.513,394.363,189.7,399.535Z",
    transform: "translate(-141.848 -347.737)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 6.624,
    cy: 6.624,
    r: 6.624,
    transform: "translate(319.922 82.405)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(290.844 48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M463.72,345.79v3.317c-1.233-2.126-3.614-3.614-7.016-3.614-5.655,0-10.162,4.592-10.162,12.2s4.5,12.247,10.162,12.247a7.74,7.74,0,0,0,7.016-3.614v3.317h8.335V345.79Zm0,11.907c0,3.232-2,4.975-4.337,4.975-2.381,0-4.337-1.786-4.337-4.975,0-3.232,1.957-4.932,4.337-4.932,2.34,0,4.341,1.743,4.341,4.932Z",
    transform: "translate(-303.453 -345.493)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M313.4,358.6c0,2.764-1.533,4.38-3.955,4.38-2.381,0-3.955-1.616-3.955-4.38V345.8H297.2v13.863c0,6.294,3.444,10.206,8.973,10.206a8.47,8.47,0,0,0,7.229-3.614v3.4h8.377V345.8H313.4Z",
    transform: "translate(-297.195 -345.506)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M403.094,358.6c0,2.764-1.533,4.38-3.955,4.38-2.381,0-3.955-1.616-3.955-4.38V345.8h-8.292v13.863c0,6.294,3.445,10.206,8.973,10.206a8.47,8.47,0,0,0,7.229-3.614v3.4h8.377V345.8h-8.377Z",
    transform: "translate(-300.953 -345.506)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M372.643,349.108a7.724,7.724,0,0,0-7.012-3.615c-5.653,0-10.162,4.592-10.162,12.2s4.509,12.247,10.162,12.247a7.74,7.74,0,0,0,7.016-3.614V369.4c0,3.7-1.916,4.763-4.252,4.763-2.126,0-3.572-.893-3.912-2.424h-8.206c.6,5.911,5.188,9.653,12.63,9.653,8.589,0,12.072-5.612,12.072-11.991v-23.6h-8.335Zm-4.332,13.565c-2.381,0-4.337-1.786-4.337-4.975,0-3.232,1.956-4.932,4.337-4.932,2.339,0,4.337,1.743,4.337,4.932C372.648,360.929,370.649,362.673,368.31,362.673Z",
    transform: "translate(-299.637 -345.493)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M433.123,345.582a8.607,8.607,0,0,0-7.271,3.614v-3.4h-8.336v23.857h8.336v-12.8c0-2.764,1.533-4.38,4-4.38,2.381,0,3.912,1.616,3.912,4.38v12.8H442.1V355.744C442.1,349.494,438.651,345.582,433.123,345.582Z",
    transform: "translate(-302.236 -345.496)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 3.318,
    cy: 3.318,
    r: 3.318,
    transform: "translate(290.529 140.108)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M306.687,440.648c0,4.618,3.043,7.856,7.683,7.856a7.124,7.124,0,0,0,7.4-5.733H317.15a3.017,3.017,0,0,1-2.846,1.794c-1.97,0-3.258-1.533-3.258-3.918,0-2.364,1.292-3.9,3.258-3.9a3.018,3.018,0,0,1,2.846,1.795h4.618a7.126,7.126,0,0,0-7.4-5.729C309.73,432.817,306.687,436.052,306.687,440.648Zm32.416-.022a7.71,7.71,0,0,0-7.51-7.905q-.2,0-.391,0a7.741,7.741,0,0,0-7.924,7.554q0,.174,0,.348a7.76,7.76,0,0,0,7.594,7.923c.109,0,.219,0,.33,0a7.741,7.741,0,0,0,7.9-7.576c0-.115,0-.229,0-.344Zm-11.447,0c0-2.43,1.314-3.962,3.545-3.962,2.21,0,3.545,1.533,3.545,3.962,0,2.386-1.336,3.94-3.545,3.94-2.231,0-3.544-1.554-3.544-3.94Zm13.374,7.77h4.293v-8.58l2.933,8.581h3.59l2.911-8.515V448.4h4.29V432.965h-5.168l-3.787,10.026-3.874-10.026H341.03Z",
    transform: "translate(-6.749 -301.148)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M330.723,377.7a9.392,9.392,0,0,1,8.55.945L353.391,345.8h-9.145L339.4,359.326,334.382,345.8h-9.271l9.78,22.834Z",
    transform: "translate(-7.521 -297.506)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M334.264,398.132a9.411,9.411,0,0,1-4.485-1.13v26.511h9.334V396.8h-.023A9.4,9.4,0,0,1,334.264,398.132Z",
    transform: "translate(-7.717 -299.643)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUygunakiralaicon);
export default __webpack_public_path__ + "static/media/uygunakiralaicon.570489537d9e114b08b135bfd8c1dc02.svg";
export { ForwardRef as ReactComponent };